import { API_BASE_URL } from "../../config";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './NumberManagement.module.css'; // Reusing existing styles or create new

const AddPhoneNumber = () => {
    const [vendors, setVendors] = useState([]);
    const [formData, setFormData] = useState({
        userId: '',
        phoneNumber: '',
        useCase: 'Sales Hotline',
        type: 'inbound',
        provider: 'twilio'
    });
    const [loading, setLoading] = useState(false);
    const [loadingVendors, setLoadingVendors] = useState(true);

    const API_URL = `${API_BASE_URL}/api/numbers`;
    const VENDOR_API_URL = `${API_BASE_URL}/api/owner/vendors`;


    useEffect(() => {
        fetchVendors();
    }, []);

    const fetchVendors = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(VENDOR_API_URL, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Handle different response structures based on UserManagement analysis
            const vendorList = response.data?.data || response.data?.users || response.data || [];
            setVendors(vendorList);
        } catch (error) {
            console.error("Error fetching vendors:", error);
            toast.error("Failed to load vendors.");
        } finally {
            setLoadingVendors(false);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!formData.userId) {
            toast.error("Please select a vendor.");
            setLoading(false);
            return;
        }

        try {
            const token = localStorage.getItem("token");

            // Construct payload matching the curl request + userId
            const payload = {
                phoneNumber: formData.phoneNumber,
                useCase: formData.useCase,
                type: formData.type,
                provider: formData.provider,
                userId: formData.userId // Backend needs to support this or we change how we assign
            };

            await axios.post(API_URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            toast.success("Phone number added and assigned successfully!");
            // Reset form but keep vendor selected for convenience? Or reset all?
            setFormData({ ...formData, phoneNumber: '' });
        } catch (error) {
            console.error("Error adding number:", error);
            toast.error(error.response?.data?.message || "Failed to add phone number.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Add & Assign Phone Number</h2>
            <div className={styles.modalContent}>
                <form onSubmit={handleSubmit} className={styles.addNumberForm}>
                    {/* Vendor Selection */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Assign to Vendor (Client)</label>
                        <select
                            name="userId"
                            value={formData.userId}
                            onChange={handleChange}
                            className={styles.select}
                            required
                            disabled={loadingVendors}
                        >
                            <option value="">-- Select Vendor --</option>
                            {vendors.map(vendor => (
                                <option key={vendor._id} value={vendor._id}>
                                    {vendor.name} ({vendor.companyName || vendor.email})
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Phone Number */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Phone Number (e.g., +918035738038)</label>
                        <input
                            type="text"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            placeholder="+1234567890"
                            className={styles.input}
                            required
                        />
                    </div>

                    {/* Use Case */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Use Case</label>
                        <input
                            type="text"
                            name="useCase"
                            value={formData.useCase}
                            onChange={handleChange}
                            className={styles.input}
                        />
                    </div>

                    {/* Type */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Type</label>
                        <select
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            className={styles.select}
                        >
                            <option value="inbound">Inbound</option>
                            <option value="outbound">Outbound</option>
                        </select>
                    </div>

                    {/* Provider */}
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Provider</label>
                        <select
                            name="provider"
                            value={formData.provider}
                            onChange={handleChange}
                            className={styles.select}
                        >
                            <option value="twilio">Twilio</option>
                            <option value="plivo">Plivo</option>
                        </select>
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className={styles.buyButton}
                    >
                        {loading ? "Adding..." : "Add Phone Number"}
                    </button>

                </form>
            </div>
        </div>
    );
};

export default AddPhoneNumber;
